import { createAsyncThunk } from '@reduxjs/toolkit';
import { createLicense, deleteLicense, getAllLicenses, updateLicense } from '../../api/license/licenseService';
import { License, PaginationInterface } from './types';
import { ensureLicenseCompatibility } from '../../helpers/functions/licenseMigration';

export const createLicenseThunk = createAsyncThunk(
    'license/createLicense',
    async (license: License, thunkAPI) => {
        // Ensure the license has both legacy and modular fields
        const compatibleLicense = ensureLicenseCompatibility(license);
        return await createLicense(compatibleLicense, thunkAPI);
    }
);

export const getAllLicensesThunk = createAsyncThunk(
    'license/getAllLicenses',
    async (credentials: PaginationInterface, thunkAPI) => {
        const result = await getAllLicenses(credentials, thunkAPI);
        
        // Ensure all licenses have compatibility between legacy and modular fields
        if (result && result.collection) {
            result.collection = result.collection.map((license: License) => 
                ensureLicenseCompatibility(license)
            );
        }
        
        return result;
    }
);

export const updateLicenseThunk = createAsyncThunk(
    'license/updateLicense',
    async (license: Partial<License>, thunkAPI) => {
        // For partial updates, we don't run full compatibility check to avoid overwriting fields
        // The backend should handle the compatibility or full license retrieval
        return await updateLicense(license, thunkAPI);
    }
);

export const deleteLicenseThunk = createAsyncThunk(
    'license/deleteLicense',
    async (id: string, thunkAPI) => {
        return await deleteLicense(id, thunkAPI);
    }
);


